export default __webpack_public_path__ + "static/media/onnorokom_300_250.09277c26.gif";